import React from 'react';
import { ReactComponent as Launch } from '../images/launch_icon.svg';
import { Link } from 'react-router-dom';


const FlipCard = ({img,data}) => {
    return (
        <div  className='card-box'>
            <div className="flip-card">
                <div style={{ background: `url(${img})`,backgroundSize:'cover'}} className="front-card">
                </div>
                <div className="back-card">
                <h1 className='text-2xl font-bold '>{data.name}</h1>
                <h1 className='text-xl '>{data.title}</h1>
                <Link to={`project/${data.name}`}>
                        <Launch className='launch-icon' />
                </Link>
                      
                </div>
            </div>

        </div>
    );
};

export default FlipCard;